import fetchWithRefreshV2 from './fetchWithRefreshV2';

let auth: string =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    typeof window?.Eka?.getSessionToken === 'function' ? window.Eka.getSessionToken() : '';

const fetchAndCacheAuth = () => {
    auth =
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        typeof window?.Eka?.getSessionToken === 'function' ? window.Eka.getSessionToken() : '';
};

const refreshToken = async () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window?.Eka?.updateToken === 'function') {
        return new Promise((res) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.refreshCallback = () => {
                fetchAndCacheAuth();
                res(true);
            };
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.Eka.updateToken('refreshCallback');
        });
    }
};

const fetchWithRefresh = async (url: RequestInfo, options?: RequestInit) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window?.Eka?.getHeaders || window?.getiOSHeader) {
        return fetchWithRefreshV2(url, options);
    }

    const headers = options?.headers ? new Headers(options.headers) : new Headers();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window?.Eka && auth) {
        headers.append('auth', auth);
    }

    const res = await fetch(url, { ...options, mode: 'cors', credentials: 'include', headers });

    if (res.status === 401) {
        await refreshToken();

        headers.set('auth', auth);

        const res = await fetch(url, { ...options, mode: 'cors', credentials: 'include', headers });
        return res;
    }

    return res;
};

export default fetchWithRefresh;
